import { render, staticRenderFns } from "./awardStarModal.vue?vue&type=template&id=33ef0eee&"
import script from "./awardStarModal.vue?vue&type=script&lang=js&"
export * from "./awardStarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports